export default __webpack_public_path__ + "static/1_33-5b739fb457c054af052bb4695f7892fd.png";